import React from 'react';

const CloudUploadIcon = ({ color = '#4A9CA6', size = 20 }: { color?: string; size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25794 12.9213C4.23083 11.7629 3.83153 10.9328 3.44081 10.1653C3.05008 9.39786 2.85546 8.54557 2.8743 7.68456C2.89314 6.82354 3.12486 5.98058 3.54878 5.23093C3.9727 4.48128 4.57563 3.84826 5.30374 3.38837C6.03186 2.92848 6.86251 2.65604 7.72155 2.59536C8.58059 2.53468 9.44129 2.68765 10.2268 3.04062C11.0123 3.39359 11.6983 3.93558 12.2233 4.61819C12.7484 5.30081 13.0963 6.10283 13.236 6.95265C13.3468 6.94477 13.4497 6.93681 13.5606 6.93681C14.4009 6.93652 15.2142 7.23337 15.8567 7.77487C16.4993 8.31637 16.9296 9.06764 17.0718 9.89584C17.2139 10.724 17.0718 11.687 16.6334 12.3006C16.1153 13.0257 15.8567 13.1144 14.2699 14.0153M12.3749 14.3696L9.99991 11.9945L7.62491 14.3696M9.99621 11.9945V17.4945"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CloudUploadIcon;
